import { browserLanguages } from '.';

export const currencyFormatter = (
  currency = 'USD',
  locale = browserLanguages[0],
  options?: Intl.NumberFormatOptions,
) =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
    ...options,
  });
